import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import '../styles/Services.css';

const API_URL = process.env.REACT_APP_API_URL || '';

interface Service {
  id: number;
  name: string;
  description: string;
  icon?: string;
  duration?: number;
  price?: number;
}

const Services: React.FC = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [settings, setSettings] = useState<Record<string, string>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, settingsRes] = await Promise.all([
          axios.get(`${API_URL}/api/services`),
          axios.get(`${API_URL}/api/admin/settings`).catch(() => ({ data: [] }))
        ]);

        setServices(servicesRes.data);

        const settingsMap: Record<string, string> = {};
        if (settingsRes.data && Array.isArray(settingsRes.data)) {
           settingsRes.data.forEach((s: any) => {
             settingsMap[s.key] = s.value;
           });
        }
        setSettings(settingsMap);
      } catch (error) {
        console.error('Error fetching services data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const bannerTitle = settings['services_banner_title'] || 'Nossos Serviços';
  const bannerSubtitle = settings['services_banner_subtitle'] || 'Descubra a variedade de tratamentos que oferecemos para sua saúde e bem-estar.';

  return (
    <div className="services-page">
      <section className="hero-services">
        <div className="container">
          <h1>{bannerTitle}</h1>
          <p>{bannerSubtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="service-detail-grid">
            {services.map(service => (
              <div className="service-card" key={service.id}>
                <i className={service.icon || "fas fa-heartbeat"}></i>
                <h2>{service.name}</h2>
                <p>{service.description}</p>
                <Link to={`/agendamento?service=${encodeURIComponent(service.name)}`} className="btn btn-primary">
                  Agendar {service.name}
                </Link>
                {service.name.toLowerCase().includes('pilates') && (
                  <Link to={`/agendamento?service=${encodeURIComponent(service.name + ' - Aula Experimental')}`} className="btn btn-accent mt-2">
                    Aula Experimental Grátis!
                  </Link>
                )}
              </div>
            ))}
            {services.length === 0 && !loading && (
              <div style={{ textAlign: 'center', width: '100%', padding: '2rem' }}>
                <p>Nenhum serviço encontrado no momento.</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
